import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function ArtPaintings() {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'All Works' },
    { id: 'portraits', name: 'Portraits' },
    { id: 'paintings', name: 'Canvas Paintings' },
    { id: 'murals', name: 'Wall Murals' },
    { id: 'digital', name: 'Digital Art' },
  ];

  const artworks = [
    {
      id: 1,
      category: 'portraits',
      title: 'Realistic Portrait Study',
      description: 'Hyperrealistic pencil portrait with detailed shading',
      image: 'https://public.readdy.ai/ai/img_res/d3b95beec2839113de6084639d3ad1ec.jpg',
      price: 'From ₦15,000'
    },
    {
      id: 2,
      category: 'portraits',
      title: 'Family Portrait',
      description: 'Custom family portrait in pencil',
      image: 'https://readdy.ai/api/search-image?query=beautiful%20pencil%20drawing%20portrait%20of%20african%20family%20parents%20and%20children%20realistic%20sketch%20warm%20expression%20professional%20artwork%20on%20white%20paper%20clean%20simple%20background&width=600&height=800&seq=art-portrait-2&orientation=portrait',
      price: 'From ₦25,000'
    },
    {
      id: 3,
      category: 'portraits',
      title: 'Character Study',
      description: 'Expressive portrait with emotion',
      image: 'https://readdy.ai/api/search-image?query=expressive%20pencil%20portrait%20drawing%20of%20african%20man%20with%20strong%20character%20detailed%20shading%20professional%20charcoal%20art%20emotional%20expression%20fine%20art%20on%20white%20paper%20clean%20simple%20background&width=600&height=800&seq=art-portrait-3&orientation=portrait',
      price: 'From ₦18,000'
    },
    {
      id: 4,
      category: 'paintings',
      title: 'Abstract Expression',
      description: 'Vibrant acrylic painting on canvas',
      image: 'https://readdy.ai/api/search-image?query=vibrant%20colorful%20abstract%20acrylic%20painting%20on%20canvas%20bold%20brushstrokes%20modern%20contemporary%20art%20rich%20textures%20warm%20colors%20professional%20fine%20art%20clean%20simple%20background&width=600&height=800&seq=art-painting-1&orientation=portrait',
      price: 'From ₦30,000'
    },
    {
      id: 5,
      category: 'paintings',
      title: 'Landscape Beauty',
      description: 'Scenic landscape in oil paint',
      image: 'https://readdy.ai/api/search-image?query=beautiful%20african%20landscape%20oil%20painting%20on%20canvas%20scenic%20nature%20view%20with%20trees%20and%20sky%20warm%20sunset%20colors%20professional%20fine%20art%20realistic%20style%20clean%20simple%20background&width=600&height=800&seq=art-painting-2&orientation=portrait',
      price: 'From ₦35,000'
    },
    {
      id: 6,
      category: 'paintings',
      title: 'Cultural Heritage',
      description: 'African cultural theme painting',
      image: 'https://readdy.ai/api/search-image?query=colorful%20african%20cultural%20painting%20on%20canvas%20traditional%20patterns%20and%20symbols%20vibrant%20colors%20acrylic%20art%20contemporary%20style%20celebrating%20heritage%20professional%20artwork%20clean%20simple%20background&width=600&height=800&seq=art-painting-3&orientation=portrait',
      price: 'From ₦40,000'
    },
    {
      id: 7,
      category: 'murals',
      title: 'Office Mural',
      description: 'Large-scale wall mural for corporate space',
      image: 'https://readdy.ai/api/search-image?query=modern%20colorful%20wall%20mural%20in%20office%20space%20abstract%20geometric%20patterns%20professional%20interior%20design%20vibrant%20colors%20contemporary%20art%20on%20white%20wall%20clean%20simple%20background&width=800&height=600&seq=art-mural-1&orientation=landscape',
      price: 'Custom Quote'
    },
    {
      id: 8,
      category: 'murals',
      title: 'Children\'s Room Mural',
      description: 'Playful and colorful mural for kids',
      image: 'https://readdy.ai/api/search-image?query=colorful%20playful%20wall%20mural%20for%20children%20room%20with%20cartoon%20characters%20animals%20and%20nature%20bright%20colors%20fun%20design%20painted%20on%20white%20wall%20clean%20simple%20background&width=800&height=600&seq=art-mural-2&orientation=landscape',
      price: 'Custom Quote'
    },
    {
      id: 9,
      category: 'digital',
      title: 'Digital Portrait',
      description: 'Modern digital illustration',
      image: 'https://readdy.ai/api/search-image?query=modern%20digital%20portrait%20illustration%20of%20african%20person%20vibrant%20colors%20contemporary%20art%20style%20professional%20digital%20painting%20clean%20lines%20artistic%20composition%20clean%20simple%20background&width=600&height=800&seq=art-digital-1&orientation=portrait',
      price: 'From ₦20,000'
    },
    {
      id: 10,
      category: 'digital',
      title: 'Character Design',
      description: 'Original character concept art',
      image: 'https://readdy.ai/api/search-image?query=creative%20character%20design%20digital%20illustration%20original%20concept%20art%20colorful%20modern%20style%20professional%20digital%20painting%20unique%20character%20with%20personality%20clean%20simple%20background&width=600&height=800&seq=art-digital-2&orientation=portrait',
      price: 'From ₦25,000'
    },
    {
      id: 11,
      category: 'digital',
      title: 'Fantasy Illustration',
      description: 'Imaginative digital artwork',
      image: 'https://readdy.ai/api/search-image?query=fantasy%20digital%20illustration%20artwork%20imaginative%20scene%20with%20magical%20elements%20vibrant%20colors%20professional%20digital%20painting%20creative%20composition%20artistic%20style%20clean%20simple%20background&width=600&height=800&seq=art-digital-3&orientation=portrait',
      price: 'From ₦30,000'
    },
    {
      id: 12,
      category: 'paintings',
      title: 'Still Life Study',
      description: 'Classic still life composition',
      image: 'https://readdy.ai/api/search-image?query=beautiful%20still%20life%20painting%20on%20canvas%20with%20fruits%20and%20objects%20realistic%20style%20warm%20lighting%20professional%20oil%20painting%20classical%20composition%20fine%20art%20quality%20clean%20simple%20background&width=600&height=800&seq=art-painting-4&orientation=portrait',
      price: 'From ₦28,000'
    },
  ];

  const filteredArtworks = selectedCategory === 'all' 
    ? artworks 
    : artworks.filter(art => art.category === selectedCategory);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-r from-teal-500 to-blue-600 text-white">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Art & Paintings Gallery</h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto">
            Explore our collection of stunning artworks, from lifelike portraits to vibrant paintings
          </p>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-12 bg-white sticky top-20 z-40 shadow-sm">
        <div className="container mx-auto px-6">
          <div className="flex flex-wrap justify-center gap-3">
            {categories.map(category => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`whitespace-nowrap px-6 py-3 rounded-full font-semibold transition-all cursor-pointer ${
                  selectedCategory === category.id
                    ? 'bg-teal-500 text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredArtworks.map(artwork => (
              <div key={artwork.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all group">
                <div className="overflow-hidden">
                  <img 
                    src={artwork.image}
                    alt={artwork.title}
                    className="w-full h-96 object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold mb-2">{artwork.title}</h3>
                  <p className="text-gray-600 mb-4">{artwork.description}</p>
                  <div className="flex items-center justify-between">
                    <span className="text-teal-600 font-bold text-lg">{artwork.price}</span>
                    <Link 
                      to="/contact" 
                      className="whitespace-nowrap bg-teal-500 hover:bg-teal-600 text-white px-4 py-2 rounded-full text-sm font-semibold transition-all cursor-pointer"
                    >
                      Inquire
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Info */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl md:text-5xl font-bold mb-12 text-center">Pricing Information</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-2xl p-8">
                <h3 className="text-2xl font-bold mb-4">Portrait Drawings</h3>
                <ul className="space-y-3">
                  <li className="flex justify-between">
                    <span className="text-gray-700">A4 Size (Single Person)</span>
                    <strong className="text-teal-600">₦15,000</strong>
                  </li>
                  <li className="flex justify-between">
                    <span className="text-gray-700">A3 Size (Single Person)</span>
                    <strong className="text-teal-600">₦20,000</strong>
                  </li>
                  <li className="flex justify-between">
                    <span className="text-gray-700">Family Portrait (2-4 people)</span>
                    <strong className="text-teal-600">₦25,000+</strong>
                  </li>
                </ul>
              </div>

              <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-2xl p-8">
                <h3 className="text-2xl font-bold mb-4">Canvas Paintings</h3>
                <ul className="space-y-3">
                  <li className="flex justify-between">
                    <span className="text-gray-700">Small Canvas (12x16)</span>
                    <strong className="text-purple-600">₦25,000</strong>
                  </li>
                  <li className="flex justify-between">
                    <span className="text-gray-700">Medium Canvas (16x20)</span>
                    <strong className="text-purple-600">₦35,000</strong>
                  </li>
                  <li className="flex justify-between">
                    <span className="text-gray-700">Large Canvas (24x36)</span>
                    <strong className="text-purple-600">₦50,000+</strong>
                  </li>
                </ul>
              </div>

              <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-8">
                <h3 className="text-2xl font-bold mb-4">Digital Illustrations</h3>
                <ul className="space-y-3">
                  <li className="flex justify-between">
                    <span className="text-gray-700">Portrait Illustration</span>
                    <strong className="text-blue-600">₦20,000</strong>
                  </li>
                  <li className="flex justify-between">
                    <span className="text-gray-700">Character Design</span>
                    <strong className="text-blue-600">₦25,000</strong>
                  </li>
                  <li className="flex justify-between">
                    <span className="text-gray-700">Complex Scene</span>
                    <strong className="text-blue-600">₦30,000+</strong>
                  </li>
                </ul>
              </div>

              <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-2xl p-8">
                <h3 className="text-2xl font-bold mb-4">Wall Murals</h3>
                <ul className="space-y-3">
                  <li className="flex justify-between">
                    <span className="text-gray-700">Small Wall (up to 50 sq ft)</span>
                    <strong className="text-red-600">₦40,000</strong>
                  </li>
                  <li className="flex justify-between">
                    <span className="text-gray-700">Medium Wall (50-100 sq ft)</span>
                    <strong className="text-red-600">₦70,000</strong>
                  </li>
                  <li className="flex justify-between">
                    <span className="text-gray-700">Large Wall (100+ sq ft)</span>
                    <strong className="text-red-600">Custom Quote</strong>
                  </li>
                </ul>
              </div>
            </div>

            <div className="mt-12 bg-gray-100 rounded-2xl p-8 text-center">
              <p className="text-lg text-gray-700 mb-4">
                <strong>Note:</strong> Prices may vary based on complexity, size, and materials. Contact us for a detailed quote.
              </p>
              <Link 
                to="/contact" 
                className="whitespace-nowrap inline-block bg-teal-500 hover:bg-teal-600 text-white px-8 py-4 rounded-full text-lg font-semibold transition-all cursor-pointer"
              >
                Request Custom Quote
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-purple-500 to-pink-600">
        <div className="container mx-auto px-6 text-center text-white">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">Commission Your Custom Artwork</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Have a specific vision in mind? Let's bring it to life together
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link 
              to="/contact" 
              className="whitespace-nowrap bg-white hover:bg-gray-100 text-purple-600 px-8 py-4 rounded-full text-lg font-semibold transition-all cursor-pointer shadow-lg"
            >
              Start Your Commission
            </Link>
            <a 
              href="tel:08162117807" 
              className="whitespace-nowrap bg-transparent hover:bg-white/10 text-white border-2 border-white px-8 py-4 rounded-full text-lg font-semibold transition-all cursor-pointer"
            >
              Call: 08162117807
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}